// careerReducer.js

import {
    UPDATE_TITLE,
    UPDATE_DESC_POINTS
  } from './actions.js';
  
  const initialState = {
    title: "",
    descPoints: [],

  };
  
  const careerReducer = (state = initialState, action) => {
    switch (action.type) {
      
      case UPDATE_TITLE:
        return {
          ...state,
          title: action.payload,
        };
      
      case UPDATE_DESC_POINTS:
        return {
          ...state,
          descPoints: action.payload,
        };
      
      default:
        return state;
    }
  };
  
  export default careerReducer;
  